<script lang="ts">
  import AtAGlanceRow from './AtAGlanceRow.svelte';

  /**
   *  @type {string}
   */
  export let name;

  /**
   * A readable Svelte store of an individual Race.
   *
   *  @type {import('../types.d').RaceFeed}
   */
  export let race;

  /**
   * @type {Map<string, import('../types.d').Crosswalk>}
   */
  export let crosswalk;

  const cleanNames = {
    "0":"L.A. County Sheriff",
    "M":"Los Angeles Mayor"
  }

  //console.log($race)

</script>

<p class="aag-race">{#if $race.seat_name == "Los Angeles"}{cleanNames[$race.office]}{:else}{$race.name}{/if}</p>

<table class="contest__candidates aag">
  <tbody>
    {#each $race.candidates as c, idx (c.ap_id)}
      {#if idx < 2}
        <tr
          class="candidate contest__candidate-row contest__candidate-row-{c.party}"
          class:contest__candidate-row-winner={c.is_winner}
        >
          <AtAGlanceRow
            candidateGivenName={c.given_name}
            candidateFamilyName={c.family_name}
            isIncumbent={c.is_incumbent}
            isWinner={c.is_winner}
            candidateParty={c.party}
            candidateVotes={c.votes}
            totalVotes={$race.total_votes}
            lookup={crosswalk.get(c.ap_id)}
            raceID={$race.id}
          />
        </tr>
      {/if}
    {/each}
  </tbody>
  <tfoot>
    <tr>
      <td class="contest__precincts" colspan="2"
        >{$race.eevp}% of expected vote in</td
      >
    </tr>
  </tfoot>
</table>
